import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { CommonService } from '../../services/common/common.service';
import { StorageService } from '../../services/storage/storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../common/apiUrlHelper';
import { CookieService } from 'ngx-cookie-service';
import { LogInConstant } from 'src/app/constants/label-constants';
import { AuthService } from 'src/app/services/auth/auth.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup = this.formBuilder.group({});
  password = '';
  show = false;
  submitted = false;
  cookieEmail: string = '';
  cookiePassword: string = '';
  IsShowPassword: boolean = false;
  loginConstant: any = [];
  constructor(
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private toster: ToastrService,
    private apiUrl: ApiUrlHelper,
    private cookieService: CookieService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.loginConstant = LogInConstant;
    this.password = 'password';
    if (localStorage.getItem('authToken')) {
      const currentUserRole = this.authService.getAdminRoleId();
      this.commonService.defaultPageRedirection(currentUserRole);
    }
    this.initLoginForm();
    this.fetchData();
  }

  get loginFormControl() {
    return this.loginForm.controls;
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault(); 
  }

  initLoginForm() {
    this.loginForm = this.formBuilder.group({
      emailAddress: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
       // TODO: set default cred, remove once tested
      password: ['', [Validators.required]],
      rememberMe: [false]
    });
  }

  login() {
    this.submitted = true;
    if (this.loginForm.invalid || !this.loginForm.value.emailAddress || !this.loginForm.value.password) {
      return;
    }
    this.spinner.show();
    let objData = {
      emailId: this.loginForm.value.emailAddress.toLowerCase().trim(),
      password: this.loginForm.value.password
    };
    const apiUrl = this.apiUrl.apiUrl.login.LoginUser;
    localStorage.clear();
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (data) => {
        if (data.success) {
          this.spinner.hide();
          this.storageService.setValue('authToken', data.data.jwtToken);
          this.storageService.setValue('userId', data.data.userId);
          this.storageService.setValue('fullName', data.data.fullName);
          this.storageService.setValue('adminRoleId', data.data.adminRoleId);
          this.storageService.setValue('photo',data.data.photo);
          this.storageService.setValue('companyId',data.data.companyId);
          if (this.loginForm.value.rememberMe) {
            this.cookieService.set('rememberMe', 'yes');
            this.cookieService.set('password', this.loginForm.value.password);
            this.cookieService.set('emailId', this.loginForm.value.emailAddress.toLowerCase().trim());
          }
          else {
            this.cookieService.deleteAll();
          }
          const currentUserRole = this.authService.getAdminRoleId();
          this.commonService.defaultPageRedirection(currentUserRole);
        }
        else {
          this.spinner.hide();
          this.toster.error(data.message);
        }
      },
      error: (er) => {
        this.spinner.hide();
        console.error(er);
        localStorage.clear();
      }
    });
  }

  fetchData() {
    const cookierememberMe = this.cookieService.get('rememberMe');
    const localrememberMe = this.storageService.getValue('rememberMe');
    const authToken = (this.cookieService.get('authToken'));
    const cookieemail = this.cookieService.get('emailId');
    const cookiepassword = this.cookieService.get('password');
    if (cookierememberMe == 'yes') {
      this.loginFormControl['rememberMe'].setValue(true);
      this.loginFormControl['emailAddress'].setValue(cookieemail);
      this.loginFormControl['password'].setValue(cookiepassword);
      this.cookieEmail = cookieemail;
      this.cookiePassword = cookiepassword;
    }
    else {
      this.loginFormControl['emailAddress'].setValue('');
      this.loginFormControl['password'].setValue('');
      this.loginFormControl['rememberMe'].setValue(false);
    }
  }

  showPassword() {
    this.IsShowPassword = !this.IsShowPassword;
  } 
}